/**
 * SEO configuration
 */
export const seoConfig = {
  /**
   * Site name
   */
  siteName: "Unreserved Real Estate",
  
  /**
   * Default page title
   */
  defaultTitle: "Unreserved Real Estate - Your Trusted Real Estate Platform",
  
  /**
   * Default meta description
   */
  defaultDescription:
    "Find your dream property with Unreserved Real Estate. Browse listings, connect with agents, and make informed decisions.",
  
  /**
   * Title template
   */
  titleTemplate: "%s | Unreserved Real Estate",
  
  /**
   * Default keywords
   */
  keywords: [
    "real estate",
    "property",
    "homes",
    "apartments",
    "listings",
    "buy",
    "sell",
    "rent",
  ],
  
  /**
   * Site URL
   */
  siteUrl: process.env.SITE_URL || "https://unreserved.com",
  
  /**
   * Default image for social sharing
   */
  defaultImage: "/images/og-image.jpg",
  
  /**
   * Twitter handle
   */
  twitterHandle: "@unreserved",
  
  /**
   * Facebook app ID
   */
  facebookAppId: process.env.FACEBOOK_APP_ID,
} as const;

/**
 * Generate page metadata
 */
export function generateMetadata(
  title?: string,
  description?: string,
  image?: string
) {
  return {
    title: title
      ? seoConfig.titleTemplate.replace("%s", title)
      : seoConfig.defaultTitle,
    description: description || seoConfig.defaultDescription,
    keywords: seoConfig.keywords,
    openGraph: {
      title: title || seoConfig.defaultTitle,
      description: description || seoConfig.defaultDescription,
      url: seoConfig.siteUrl,
      siteName: seoConfig.siteName,
      images: [
        {
          url: image || seoConfig.defaultImage,
          width: 1200,
          height: 630,
          alt: title || seoConfig.siteName,
        },
      ],
      type: "website",
    },
    twitter: {
      card: "summary_large_image",
      title: title || seoConfig.defaultTitle,
      description: description || seoConfig.defaultDescription,
      images: [image || seoConfig.defaultImage],
      creator: seoConfig.twitterHandle,
    },
  };
}

